import { useMutation, useQueryClient } from '@tanstack/react-query'

const API_BASE_URL = process.env.NEXT_PUBLIC_BEV_URL

interface CancelBookingRequest {
  hotelId: number
  bookingId: string
  reason: string
}

interface CancelBookingResponse {
  isSuccess: boolean
  data: any
  errors?: Array<{ message: string }>
}

const fetcher = async (data: CancelBookingRequest): Promise<CancelBookingResponse> => {
  const response = await fetch(`${API_BASE_URL}/be/booking/cancel`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    console.error('Network response was not ok', response)
  }

  return response.json()
}

export function useCancelBooking() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: CancelBookingRequest) => fetcher(data),
    onMutate: (variables) => {},
    onError: (error) => {
      console.error('Mutation error:', error)
    },
    onSuccess: () => {
      // Invalidate and refetch bookings list after cancellation
      queryClient.invalidateQueries({ queryKey: ['bookings'] })
    },
    // Prevent multiple mutations while one is in progress
    mutationKey: ['cancelBooking'],
  })

  return {
    cancelBooking: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  }
}
